import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FileUploadField from "@/components/ui/FileUploadField";
import UploadMoreIcon from "@/assets/icons/UploadMore.svg";
import ArrowDown from "@/assets/icons/ArrowDown.svg";
import InfoIcon from "@/assets/icons/InfoIcon.svg";
import { FileDetails } from "@/types/types";

const HaveMoreToShow = ({
  comments,
  setComments,
  clearFiles,
  setSetupFiles,
}: {
  setComments: React.Dispatch<React.SetStateAction<string>>;
  comments: string;
  clearFiles: boolean;
  setSetupFiles: React.Dispatch<React.SetStateAction<FileDetails[]>>;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  const arrowAnimation = {
    animate: { rotate: isOpen ? 180 : 0 },
    transition: { duration: 0.3, ease: "easeInOut" },
  };

  return (
    <div>
      {/* have more to show */}
      <div className="border-[1.5px] border-[#F0EEEE] rounded-xl h-fit overflow-hidden">
        <motion.div className="cursor-pointer" onClick={handleOpen}>
          <div className="py-4 px-3">
            {/* header */}
            <div className="flex gap-x-3">
              <div>
                <UploadMoreIcon />
              </div>
              {/* Title */}
              <div className="flex-1 space-y-1">
                <div className="flex gap-1">
                  <h6 className="text-sm leading-5 tracking-[0%] font-semibold">
                    Have more to show?
                  </h6>
                  <span>
                    <InfoIcon />
                  </span>
                </div>
                <p className="text-[#475467] text-sm leading-5 tracking-[0%]">
                  Got an alternate take or another great option? You can upload
                  more files for the brand to review.
                </p>
              </div>
              <div className="flex-end">
                <motion.div {...arrowAnimation}>
                  <ArrowDown />
                </motion.div>
              </div>
            </div>
          </div>
        </motion.div>

        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              style={{ overflow: "hidden" }}
            >
              <div className="w-full border-t-[1.5px] border-[#F0EEEE]">
                {/* content */}
                <div className="mt-9 px-3 pb-4">
                  <div className="rounded-[10px]">
                    <FileUploadField
                      clearFiles={clearFiles}
                      onFilesUploaded={(file) => setSetupFiles(file)}
                      maxFiles={1}
                    />
                  </div>
                  {/* comment */}
                  <div className="space-y-3 mt-5">
                    <p className="text-[#475467] text-[13px] font-medium leading-[125%] tracking-[-0.75%]">
                      Comment
                    </p>
                    <input
                      type="text"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                      className="text-sm text-[#667085] p-3 bg-[#F7F7F7] border border-[#F1F1F1] rounded-[10px] focus:bg-white focus:text-black transition-colors focus:outline-[#F1F1F1] w-full"
                      placeholder="Use a Plain White Background"
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default HaveMoreToShow;
